import { Router } from '@angular/router';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  //--------------beta using ----------------
   //apiUrl: 'https://localhost:44381',
  // apiUrl:'https://kdmcportalapi.amnex.com',
  // apiUrl: 'https://nmcportalapibeta.amnex.com',
 // AFCSAPIURL : 'https://kdmcafcsscspapibeta.amnex.com',
 // AFCSAPIURLMobile : 'http://localhost:1336',
 // PGURL : 'https://nmpmlpaymentgateway.amnex.com'
  //PGURL : 'https://nmpmlpaymentgatewaybeta.amnex.com'

  //--------------beta using ----------------

  // live link 
    PGURL : 'https://kdmcafcspg.amnex.com',
    AFCSAPIURL : 'https://kdmcscspapi.amnex.com',
    apiUrl:'https://kdmcportalapi.amnex.com',
    AFCSAPIURLMobile : 'http://localhost:1336',

    //apiUrl: 'https://localhost:5001',
  //  apiUrl: 'https://kdmcportalapibeta.amnex.com',
 // AFCSAPIURL : 'https://kdmcafcsscspapibeta.amnex.com',
  //PGURL : 'https://kdmcafcspgbeta.amnex.com',
 // AFCSAPIURLMobile : 'http://localhost:1336'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
